'use client';

import { useBrowserStorage } from 'hooks';
import { addVoucherToCart } from 'services/api/client';
import { useEffect } from 'react';
import { getVoucherFromUrl } from './utils';
import { PIXUM_VOUCHER_CODE_STORAGE_KEY } from '../../constants';

/**
 * VoucherToLocalStorage
 *
 * This component reacts to the URL search params and stores the voucher code in localStorage if present.
 * It does not render any UI and is intended for side-effect only.
 */
export function VoucherToLocalStorage() {
  const { setStorageObject } = useBrowserStorage<string>();

  useEffect(() => {
    const urlVoucher = getVoucherFromUrl();

    if (urlVoucher) {
      setStorageObject(PIXUM_VOUCHER_CODE_STORAGE_KEY, urlVoucher);
      addVoucherToCart(urlVoucher);
    }
  }, []);

  return null;
}
